<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Acolhimentos") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Acolhimentos"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>

        <b-dropdown-group id="dropdown-group-1">
          <!-- Relatório de unidades -->
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/home'"
            :disabled="
              $route.name ===
              'relatorios_home_acolhimentos'
            "
          >
            Todas as Unidades de Acolhimento
          </b-dropdown-item>

          <!-- Gráficos de unidades -->
          <b-dropdown-item
            :to="
              '/dashboard/relatorios/acolhimentos/graficos'
            "
            :disabled="
              $route.name === 'graficos_acolhimentos'
            "
          >
            Gráficos de Unidades de Acolhimento
          </b-dropdown-item>

          <!-- Relatório unificado -->
          <b-dropdown-item
            :to="
              '/dashboard/relatorios/acolhimentos/geral/home'
            "
            :disabled="
              $route.name ===
              'relatorios_acolhimentos_geral'
            "
          >
            Acolhimentos em Geral
          </b-dropdown-item>

          <!-- Gráficos unificados -->
          <b-dropdown-item
            :to="
              '/dashboard/relatorios/acolhimentos/geral/graficos'
            "
            :disabled="
              $route.name ===
              'graficos_acolhimentos_geral'
            "
          >
            Gráficos de Acolhimentos
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>

    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportsAcolhimentos",

  metaInfo() {
    return {
      title: this.$i18n.t(
        "Relatórios de Acolhimentos"
      ),
    };
  },

  data() {
    return {
      loading: false,
    };
  },
};
</script>